module.exports = __webpack_public_path__ + "jtails-build/img/store_big@2.90df250e.jpg";